// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleGroupManifest } from '@platform/core/types/modularity/IModuleGroupManifest';
import { basicGroup } from './basic';
import { documentsGroup } from './documents';
import { managementGroup } from './management';
import { projectsGroup } from './projects';
import { expertsGroup } from './experts';
import { developmentGroup } from './development';
import { aiManagementGroup } from './ai-management';
import { settingsGroup } from './settings';
import { committeesGroup } from './committees';
import { relationshipManagementGroup } from './relationship-management';
import { communicationsGroup } from './communications';
import { analysisGroup } from './analysis';
import { creativeGroup } from './creative';
import { legislationGroup } from './legislation';
import { legalGroup } from './legal';
import { constituentsGroup } from './constituents';
import { oversightGroup } from './oversight';
import { partyAndGroupGroup } from './party-and-group';
import { advocacyGroup } from './advocacy';
import { officeGroup } from './office';
import { metaGroup } from './meta';

/** Реєстр пакетів груп модулів (21); тіла модулів завантажуються ліниво через маніфести. */
export const moduleGroups: IModuleGroupManifest[] = [basicGroup, documentsGroup, managementGroup, projectsGroup, expertsGroup, developmentGroup, aiManagementGroup, settingsGroup, committeesGroup, relationshipManagementGroup, communicationsGroup, analysisGroup, creativeGroup, legislationGroup, legalGroup, constituentsGroup, oversightGroup, partyAndGroupGroup, advocacyGroup, officeGroup, metaGroup];
